import dynamic from "next/dynamic";
import Head from "next/head";
import striptags from "striptags";
import React, { useEffect, useState } from "react";
const Article = dynamic(() => import("../Blog/Article"));
const AllArticle = dynamic(() => import("../Blog/AllArticle"));
const CommonCtaSection = dynamic(() => import("../common/CTASection/CommonCtaSection"));
const Loader = dynamic(() => import("../common/Loader/Loader"));

const Blog = ({ blogData, blogPage }) => {
  const [loader, setLoader] = useState(true);
  const commonCtaData = blogPage?.body?.find((block) => block?.type === "cta");
  useEffect(() => {
    blogData && setLoader(false);
  }, []);
  const title = blogPage?.page_title || 'Blog';
  const seo_title = blogPage?.meta?.seo_title;
  const search_description = blogPage?.meta?.search_description;
  const canonicalUrl = blogPage?.canonical_url;
  const ogImage = blogPage.og_image;
  const og_title = blogPage?.og_title;
  const og_description = blogPage?.og_description;
  const og_image = blogPage?.og_image?.url;
  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />
        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta itemprop="image" content={ogImage} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />

      </Head>
      {loader && <Loader />}
      <main className="main-wrapper blog-page-middle wrapper-top-bg">
        <article className="wrapper-inner">
          <Article data={blogData?.latest_articles} />
          <AllArticle
            articleData={blogData?.articles}
            categoryData={blogData?.category}
          />
          <CommonCtaSection data={commonCtaData} />
        </article>
      </main>
    </>
  );
};

export default Blog;
